import {
  breadcrumb_item_styles_default
} from "./chunk.FLTQRQBR.js";
import {
  component_mobile_styles_default
} from "./chunk.3DO35SD7.js";
import {
  r
} from "./chunk.4JTBA2KG.js";

// src/components/breadcrumb/breadcrumb-item.styles.ts
var breadcrumb_item_styles_default2 = r` ${component_mobile_styles_default} ${breadcrumb_item_styles_default} .breadcrumb-item { font-weight: var(--sl-font-weight-normal); color: var(--sl-color-gray-800); } :host(:not(:last-of-type)) .breadcrumb-item__label { color: var(--sl-color-primary-600); font-weight: var(--sl-font-weight-semibold); } :host(:not(:last-of-type)) .breadcrumb-item__label:hover { color: var(--sl-color-primary-700); font-weight: var(--sl-font-weight-normal); font-style: normal; } :host(:not(:last-of-type)) .breadcrumb-item__label:active { color: var(--sl-color-primary-600); } :host(:not(:last-of-type)) .breadcrumb-item__label:inactive { color: var(--sl-color-primary-400); } .breadcrumb-item__separator { color: var(--sl-color-primary-600); } :host([disabled]) .breadcrumb-item__label, :host([disabled]) .breadcrumb-item__label:hover { color: var(--sl-color-primary-400); font-weight: var(--sl-font-weight-normal); cursor: not-allowed; } `;

export {
  breadcrumb_item_styles_default2 as breadcrumb_item_styles_default
};
